import React from 'react';
import ContentElement from './configuratorElements/ContentElement.react';
import './../../../dist/theme/src/rc-collapse.css'
import Collapse, { Panel } from 'rc-collapse';
import objectPath from 'object-path';

class ConfiguratorContentAccordion extends React.Component {

    static get defaultProps() {
        return {
            ConfiguratorManager: {},
            groupedContentElements: [],
        }
    }
    
    render() {

        const { groupedContentElements, ConfiguratorManager, currentLocale  } = this.props;

        return (
            <Collapse accordion={false}>
                    {

                        groupedContentElements.map(function(group, i) {

                            let groupTitle = objectPath.get(group, 'translationsSorted.' + currentLocale + '.name');
                            if (!groupTitle) {
                                groupTitle = group.name;
                            }

                            return <Panel header={groupTitle} key={i}>
                                {
                                    group.contentElements.map(function (content, i) {

                                        const preparedData = ConfiguratorManager.getContentElementDataByLocale(content, ConfiguratorManager.getDocumentStorageLocale());
                                        let elementTitle = objectPath.get(content, 'translationsSorted.' + currentLocale + '.customSpecificationTranslated.title');
                                        if(!elementTitle) elementTitle = content.name;

                                        return <ContentElement id={content.id} key={content.id}
                                                               title={elementTitle} data={preparedData} />
                                    })
                                }
                                </Panel>
                        })
                    }
            </Collapse>
        );
    }
}

export default ConfiguratorContentAccordion;


// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorContentAccordion.react.jsx